import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twotwo-twothree',
  templateUrl: './twotwo-twothree.component.html',
  styleUrls: ['./twotwo-twothree.component.scss']
})
export class TwotwoTwothreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
